import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { useState, type ReactNode } from 'react';

import { sampleLabelOf } from '@/shared/api/sample-data';

import { createQueryClient, dexiePersister } from './query-client';

export function QueryProvider({ children }: { children: ReactNode }) {
    const [queryClient] = useState(createQueryClient);

    return (
        <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{
                persister: dexiePersister,
                maxAge: 7 * 24 * 60 * 60 * 1_000,
                /* Elke build begint schoon: bewaarde gegevens van een oudere versie passen niet altijd meer. */
                buster: __APP_BUILD__,
                dehydrateOptions: {
                    /*
                     * Een publieke rapportpagina wordt bekeken door de kóper, niet
                     * door de eigenaar van dit apparaat. Die gegevens mogen dus niet
                     * in de IndexedDB van een gedeelde tablet achterblijven.
                     */
                    shouldDehydrateQuery: (query) =>
                        query.state.status === 'success' &&
                        !String(query.queryKey[0] ?? '').startsWith('public') &&
                        /* Voorbeelddata hoort niet op een koude start terug te komen alsof het echt is. */
                        sampleLabelOf(query.state.data) === null,
                },
            }}
        >
            {children}
        </PersistQueryClientProvider>
    );
}
